
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { FormData } from "./types";

interface Props {
  setFormData: (data: FormData) => void;
  formData: FormData;
}

const EditUserPhoneInput = ({ setFormData, formData }: Props) => (
  <div className="grid gap-2">
    <Label htmlFor="phone_number">Phone Number</Label>
    <Input
      id="phone_number"
      value={formData.phone_number || ""}
      onChange={e => setFormData({ ...formData, phone_number: e.target.value })}
      placeholder="+1234567890"
    />
  </div>
);

export default EditUserPhoneInput;
